import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=69c7f75c"
import script from "./Appeal.vue?vue&type=script&lang=js"
export * from "./Appeal.vue?vue&type=script&lang=js"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=69c7f75c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports